import { render } from "./DigitAnimation.vue?vue&type=template&id=cb20b16e&scoped=true"
import script from "./DigitAnimation.vue?vue&type=script&lang=js"
export * from "./DigitAnimation.vue?vue&type=script&lang=js"

import "./DigitAnimation.vue?vue&type=style&index=0&id=cb20b16e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb20b16e"]])

export default __exports__